import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=487a042f&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a042f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487a042f')) {
      api.createRecord('487a042f', component.options)
    } else {
      api.reload('487a042f', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=487a042f&scoped=true&", function () {
      api.rerender('487a042f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MDeaRmsC4qOw/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports